module.exports = __webpack_public_path__ + "img/ico_bajar.179062a9.svg";